export default "__VITE_ASSET__CA5U9LWG__"